import styled from 'styled-components';
import { mediaQueryMobileMin } from 'styleUtils';
import { BreadCrumbsWrapper as BaseWrapper } from 'components/FooterStyles';
export var BreadCrumbsWrapper = /*#__PURE__*/styled(BaseWrapper).withConfig({
  componentId: "sc-1ve8x58-0"
})(["padding:16px;@media ", "{padding:24px 16px;}"], mediaQueryMobileMin);
export default BreadCrumbsWrapper;